export default __webpack_public_path__ + "static/media/off.0769505a.svg";